
// Module
import routes from './routes';

export default angular.module( 'app.signup.module',
    [] )
    .config(routes)
    .name;



/** WEBPACK FOOTER **
 ** ./src/guest/signup/index.js
 **/